/* global Knitiv */

export default class ModalLoginWorkspacesController {
	/* @ngInject */
	/**
	 * @param {import('angular').ILocationService} $location
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {boolean} admin
	 * @param {import('@knitiv/api-client-javascript').WorkspaceListOutput['urls']} urls
	 * @param {import('@knitiv/api-client-javascript').WorkspaceListOutput['workspaces']} workspaces
	 */
	constructor(
		$location,
		$rootScope,
		$translate,
		$uibModalInstance,
		admin,
		urls,
		workspaces,
	) {
		this.$location = $location;
		this.$rootScope = $rootScope;
		this.$translate = $translate;
		this.$uibModalInstance = $uibModalInstance;
		this.admin = admin;
		this.workspaces = workspaces;

		const protocol = $location.protocol();
		const host = $location.host();
		const port = $location.port();
		const baseUrl = new URL(protocol + '://' + host + (port ? ':' + port : ''));

		this.urls = urls?.map(u => {
			const url = new URL(u);
			return {
				link: u,
				active: baseUrl.host === url.host,
			}
		});

		/** @type {string | undefined} */
		this.date = undefined;

		this.datePickerOptions = {
			allowInput:        true,
			altFormat:         'd/m/Y H:i:S',
			dateFormat:        'd/m/Y H:i:S',
			displayInput:      true,
			enableTime:        true,
			label:             $translate.instant('common.date'),
			placeholder:       $translate.instant('common.now'),
			static:            true,
			time_24hr:         true,
		};

		this.$rootScope.title = 'workspaces.title';
	}

	/**
	 * @param {string} environment
	 * @param {any} database
	 */
	selectWorkspace(environment, database) {
		this.$uibModalInstance.close({
			env: environment,
			database,
			date: this.date,
		});
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}
}
